// extracted by mini-css-extract-plugin
module.exports = {"carousel-handlers":"_3JkFMntD","carouselHandlers":"_3JkFMntD","prev":"_3R0n0bTH","next":"_17ZAiddZ"};